import { ServiceType } from "@agroyaar/sdk";
import { Column } from "../../../domain/report-template.interface";
import { getLightShades } from "../../../utils/report-color";

interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  serviceType?: ServiceType;
}
export function Table<T extends object>({
  columns,
  data,
  serviceType,
}: TableProps<T>) {
  const { lighter, baseColor } = getLightShades(
    serviceType ?? "CROPPING_PATTERN"
  );

  return (
    <div className="overflow-x-auto rounded-md border border-black">
      <table className="min-w-full border border-black border-collapse text-center">
        <thead style={{ backgroundColor: lighter }}>
          <tr>
            {columns.map((col) => (
              <th
                key={String(col.field)}
                className="px-4 py-2 border border-black font-semibold text-[16px] !font-[B-Nazanin]"
                style={{ color: baseColor }}
              >
                {col.headerName}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-gray-50">
              {columns.map((col) => {
                const rawValue = row[col.field];

                let value: React.ReactNode;
                if (col.render) {
                  value = col.render(rawValue, row);
                } else if (rawValue == null) {
                  value = "-";
                } else if (
                  col.format === "decimal" &&
                  typeof rawValue === "number"
                ) {
                  value = rawValue.toFixed();
                } else if (
                  col.format === "number" &&
                  typeof rawValue === "number"
                ) {
                  value = new Intl.NumberFormat("fa-IR").format(rawValue);
                } else {
                  value = String(rawValue);
                }

                return (
                  <td
                    key={`${rowIndex}-${String(col.field)}`}
                    className="px-4 py-2 border border-black !font-[B-Nazanin]"
                  >
                    {value}
                  </td>
                );
              })} 
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
